const env = import.meta.env;
const runtime = typeof window !== 'undefined' ? window.ENV_CONFIG : undefined;

function toSampleRate(value: string | number | undefined, fallback: number): number {
  if (value === undefined || value === '') return fallback;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n >= 0 && n <= 100 ? n : fallback;
}

export const appConfig = {
  apiBaseUrl: (runtime?.apiBaseUrl ?? (env.DEV ? '' : (env.VITE_API_BASE_URL ?? ''))).replace(
    /\/+$/,
    '',
  ),
  environment: runtime?.environment || env.VITE_ENVIRONMENT || 'local',
  version: env.VITE_APP_VERSION as string | undefined,
  datadog: {
    rumAppId: runtime?.datadogRumAppId ?? env.VITE_DATADOG_RUM_APP_ID,
    rumClientToken: runtime?.datadogRumClientToken ?? env.VITE_DATADOG_RUM_CLIENT_TOKEN,
    remoteConfigId: runtime?.datadogRemoteConfigId ?? env.VITE_DATADOG_REMOTE_CONFIG_ID,
    sessionSampleRate: toSampleRate(env.VITE_RUM_SESSION_SAMPLE_RATE, 100),
    replaySampleRate: toSampleRate(env.VITE_RUM_REPLAY_SAMPLE_RATE, 20),
  },
  allowedDeeplinkPrefixes:
    env.VITE_ALLOWED_DEEPLINK_PREFIXES ??
    'uhcm://,optumapp://,myuhc-mobile://,https://www.optum.com,https://www.uhc.com,uhc-mobile://,optum://',
};
